import funderDetailsActionTypes from './funder-details.types';

/** ***************** GET FUNDER DETAILS LIST START *********************** */
export const getFunderDetailsListStart = (getData: any) => ({
	type: funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_START,
	payload: getData,
});

export const getFunderDetailsListSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_SUCCESS,
	payload: successData,
});

export const getFunderDetailsListFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_FAILURE,
	payload: failureData,
});

export const getFunderDetailsListReset = () => ({
	type: funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_RESET,
});

export const getFunderDetailsListChanged = () => ({
	type: funderDetailsActionTypes.GET_FUNDER_DETAILS_LIST_CHANGED,
});
/** ***************** GET FUNDER DETAILS LIST END *********************** */

/** ***************** ADD FUNDER DETAILS START *********************** */
export const addFunderDetailsStart = (addData: any) => ({
	type: funderDetailsActionTypes.ADD_FUNDER_DETAILS_START,
	payload: addData,
});

export const addFunderDetailsSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.ADD_FUNDER_DETAILS_SUCCESS,
	payload: successData,
});

export const addFunderDetailsFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.ADD_FUNDER_DETAILS_FAILURE,
	payload: failureData,
});

export const addFunderDetailsReset = () => ({
	type: funderDetailsActionTypes.ADD_FUNDER_DETAILS_RESET,
});

export const addFunderDetailsChanged = () => ({
	type: funderDetailsActionTypes.ADD_FUNDER_DETAILS_CHANGED,
});
/** ***************** ADD FUNDER DETAILS END *********************** */

/** ***************** UPDATE FUNDER DETAILS START *********************** */
export const updateFunderDetailsStart = (updateData: any) => ({
	type: funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_START,
	payload: updateData,
});

export const updateFunderDetailsSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_SUCCESS,
	payload: successData,
});

export const updateFunderDetailsFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_FAILURE,
	payload: failureData,
});

export const updateFunderDetailsReset = () => ({
	type: funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_RESET,
});

export const updateFunderDetailsChanged = () => ({
	type: funderDetailsActionTypes.UPDATE_FUNDER_DETAILS_CHANGED,
});
/** ***************** UPDATE FUNDER DETAILS END *********************** */

/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT START ************************** */
export const fetchInvestmentProductInvestmentAmountStart = (getData: any) => ({
	type: funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_START,
	payload: getData,
});

export const fetchInvestmentProductInvestmentAmountSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_SUCCESS,
	payload: successData,
});

export const fetchInvestmentProductInvestmentAmountFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_FAILURE,
	payload: failureData,
});

export const fetchInvestmentProductInvestmentAmountResponseResetStart = () => ({
	type: funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_RESPONSE_RESET,
});

export const fetchInvestmentProductInvestmentAmountResponseChanged = () => ({
	type: funderDetailsActionTypes.FETCH_INVESTMENT_PRODUCT_INVESTMENT_AMOUNT_RESPONSE_CHANGED,
});

/************** FETCH INVESTMENT PRODUCT INVESTMENT AMOUNT END ************************** */

/************** FETCH ALL INVESTMENT MADE LIST START ************************** */
export const fetchAllInvestmentMadeListStart = (getData: any) => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_START,
	payload: getData,
});
export const fetchAllInvestmentMadeListSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_SUCCESS,
	payload: successData,
});
export const fetchAllInvestmentMadeListFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_FAILURE,
	payload: failureData,
});
export const fetchAllInvestmentMadeListResponseResetStart = () => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_RESPONSE_RESET,
});
export const fetchAllInvestmentMadeListResponseChanged = () => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_MADE_LIST_RESPONSE_CHANGED,
});
/************** FETCH ALL INVESTMENT MADE LIST END ************************** */

/************** FETCH ALL INVESTMENT REPAYMENT LIST START ************************** */
export const fetchAllInvestmentRepaymentListStart = (getData: any) => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_START,
	payload: getData,
});

export const fetchAllInvestmentRepaymentListSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_SUCCESS,
	payload: successData,
});

export const fetchAllInvestmentRepaymentListFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_FAILURE,
	payload: failureData,
});

export const fetchAllInvestmentRepaymentListResponseResetStart = () => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_RESPONSE_RESET,
});

export const fetchAllInvestmentRepaymentListResponseChanged = () => ({
	type: funderDetailsActionTypes.FETCH_ALL_INVESTMENT_REPAYMENT_LIST_RESPONSE_CHANGED,
});

/************** FETCH ALL INVESTMENT REPAYMENT LIST END ************************** */

/** ***************** DELETE FUNDER DETAILS START *********************** */
export const deleteFunderDetailsStart = (deleteData: any) => ({
	type: funderDetailsActionTypes.DELETE_FUNDER_DETAILS_START,
	payload: deleteData,
});

export const deleteFunderDetailsSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.DELETE_FUNDER_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteFunderDetailsFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.DELETE_FUNDER_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteFunderDetailsReset = () => ({
	type: funderDetailsActionTypes.DELETE_FUNDER_DETAILS_RESET,
});

export const deleteFunderDetailsChanged = () => ({
	type: funderDetailsActionTypes.DELETE_FUNDER_DETAILS_CHANGED,
});
/** ***************** DELETE FUNDER DETAILS END *********************** */

/** ***************** DELETE FUNDER DETAILS START *********************** */
export const createInvestorMadeStart = (deleteData: any) => ({
	type: funderDetailsActionTypes.CREATE_INVESTOR_MADE_START,
	payload: deleteData,
});

export const createInvestorMadeSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.CREATE_INVESTOR_MADE_SUCCESS,
	payload: successData,
});

export const createInvestorMadeFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.CREATE_INVESTOR_MADE_FAILURE,
	payload: failureData,
});

export const createInvestorMadeReset = () => ({
	type: funderDetailsActionTypes.CREATE_INVESTOR_MADE_RESET,
});

export const createInvestorMadeChanged = () => ({
	type: funderDetailsActionTypes.CREATE_INVESTOR_MADE_CHANGED,
});
/** ***************** DELETE FUNDER DETAILS END *********************** */

/** ***************** GET INVESTOR DETAILS START *********************** */
export const getInvestorsDetailsStart = (deleteData: any) => ({
	type: funderDetailsActionTypes.GET_INVESTORS_DETAILS_START,
	payload: deleteData,
});

export const getInvestorsDetailsSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.GET_INVESTORS_DETAILS_SUCCESS,
	payload: successData,
});

export const getInvestorsDetailsFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.GET_INVESTORS_DETAILS_FAILURE,
	payload: failureData,
});

export const getInvestorsDetailsReset = () => ({
	type: funderDetailsActionTypes.GET_INVESTORS_DETAILS_RESET,
});

export const getInvestorsDetailsChanged = () => ({
	type: funderDetailsActionTypes.GET_INVESTORS_DETAILS_CHANGED,
});
/** ***************** GET INVESTOR DETAILS END *********************** */

/** ***************** GET BRANCH ACCOUNT LIST START *********************** */
export const getBranchAccountListStart = (deleteData: any) => ({
	type: funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_START,
	payload: deleteData,
});

export const getBranchAccountListSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_SUCCESS,
	payload: successData,
});

export const getBranchAccountListFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_FAILURE,
	payload: failureData,
});

export const getBranchAccountListReset = () => ({
	type: funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_RESET,
});

export const getBranchAccountListChanged = () => ({
	type: funderDetailsActionTypes.GET_BRANCH_ACCOUNT_LIST_CHANGED,
});
/** ***************** GET BRANCH ACCOUNT LIST END *********************** */

/** ***************** GET BRANCH ACCOUNT LIST START *********************** */
export const getRepaymentScheduleStart = (deleteData: any) => ({
	type: funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_START,
	payload: deleteData,
});

export const getRepaymentScheduleSuccess = (successData: any) => ({
	type: funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_SUCCESS,
	payload: successData,
});

export const getRepaymentScheduleFailure = (failureData: any) => ({
	type: funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_FAILURE,
	payload: failureData,
});

export const getRepaymentScheduleReset = () => ({
	type: funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_RESET,
});

export const getRepaymentScheduleChanged = () => ({
	type: funderDetailsActionTypes.GET_REPAYMENT_SCHEDULE_CHANGED,
});
/** ***************** GET BRANCH ACCOUNT LIST END *********************** */
